import { render, staticRenderFns } from "./SlightRobotRestart.vue?vue&type=template&id=04293b3a&"
import script from "./SlightRobotRestart.vue?vue&type=script&lang=js&"
export * from "./SlightRobotRestart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports